import { Paper } from "@mui/material";
import { Fragment, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoginImage from "assets/images/login.jpg";

export function Intercept() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    navigate(`/login?redirect_uri=${encodeURIComponent(currentPath)}`);
  }, [location, navigate]);

  return (
    <Paper
      sx={{
        backgroundImage: `url(${LoginImage})`,
        width: "100%",
        height: "100vh",
        backgroundPosition: "center",
        backgroundSize: "cover",
        borderRadius: 0,
      }}
    >
      <Fragment />
    </Paper>
  );
}
